import React from "react";
import PropTypes from "prop-types";
import { Button } from "@sainsburys-tech/fable";
import LoadingWrapper from "../LoadingWrapper";

const ShowMorePager = props => (
  <div>
    <LoadingWrapper isLoading={props.isPaging}>
      <Button variant="tertiary" onClick={props.onPageChange}>Show more</Button>
    </LoadingWrapper>
  </div>
);

ShowMorePager.propTypes = {
  isPaging: PropTypes.bool,
  onPageChange: PropTypes.func
};

export default ShowMorePager;
